import { render } from "./error-page.vue?vue&type=template&id=98a56590&scoped=true&ts=true"
import script from "./error-page.vue?vue&type=script&lang=ts"
export * from "./error-page.vue?vue&type=script&lang=ts"

import "./error-page.vue?vue&type=style&index=0&id=98a56590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a56590"]])

export default __exports__